var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 25.3064C27.2343 27.0055 26.8688 27.7639 25.8828 29.2651C24.5091 31.3614 22.571 33.9725 20.1693 33.9946C18.0359 34.0146 17.4876 32.6034 14.5915 32.6204C11.6953 32.6374 11.0917 34.0197 8.95831 33.9998C6.55664 33.9784 4.72167 31.6206 3.34655 29.5228C-0.497313 23.6598 -0.898943 16.7799 1.47178 13.1226C3.15642 10.5219 5.81528 9.00222 8.31423 9.00222C10.8589 9.00222 12.4588 10.4 14.5634 10.4C16.6048 10.4 17.848 9 20.7906 9C23.0146 9 25.3714 10.2132 27.0508 12.3096C21.5481 15.3304 22.4428 23.2012 28 25.3064V25.3064Z",
    fill: "#53B175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2918 5.39699C20.4013 3.9966 21.2424 2.02086 20.9366 0C19.1243 0.121838 17.0062 1.25599 15.769 2.73384C14.6457 4.07482 13.7182 6.06409 14.0791 7.99771C16.0558 8.05863 18.1028 6.89665 19.2918 5.39699Z",
    fill: "#53B175"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.eec985d4ff37a550409c58f28af28b4f.svg";
export { ForwardRef as ReactComponent };